<template>
  <div class="group-purchase-page">
    <top-bar :topbarList="groupPurchaseTopBarList"></top-bar>
    <router-view></router-view>
  </div>
</template>

<script>
import topBar from "@/components/topBar.vue";
import { mapState } from "vuex";

import { groupPurchaseIndexMixins } from "@/mixins/groupPurchaseIndexMixins";

export default {
  mixins: [groupPurchaseIndexMixins],
  data() {
    return {};
  },
  computed: {},
  components: {
    topBar,
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.group-purchase-page {
  height: 100%;
}
</style>
